import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  background: #fff;
`;

const NavbarSpacer = styled.div`
  height: 120px;
  @media (min-width: 768px) {
    height: 140px;
  }
  @media (min-width: 1024px) {
    height: 160px;
  }
`;

const MainContent = styled.main`
  margin-bottom: 0;
`;

const PageLayout = ({ children }) => {
  return (
    <PageContainer>
      <NavbarSpacer />
      <MainContent>
        {children}
      </MainContent>
    </PageContainer>
  );
};

export default PageLayout;
